import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

const VerifyEmailInfo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const prefillEmail = location?.state?.email || '';
    const [email, setEmail] = useState(prefillEmail);
    const [token, setToken] = useState('');
    const [status, setStatus] = useState(null);
    const [autoSubmitting, setAutoSubmitting] = useState(false);
    const apiUrl = process.env.REACT_APP_API || '';

    const verify = async (em, tk) => {
        setStatus('loading');
        try {
            const res = await fetch(apiUrl + '/branduser/verify-email', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: em, token: tk }),
            });
            const data = await res.json();
            if (res.ok && data.success) {
                setStatus('success');
                setTimeout(() => navigate('/login'), 1200);
            } else {
                setStatus(data.message || 'Échec de la vérification');
            }
        } catch (err) {
            console.error(err);
            setStatus('Erreur réseau');
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qEmail = params.get('email');
        const qToken = params.get('token');
        if (qEmail) setEmail(qEmail);
        if (qToken) setToken(qToken);
        if (qEmail && qToken && !autoSubmitting) {
            setAutoSubmitting(true);
            verify(qEmail, qToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    const submitToken = async () => {
        await verify(email, token);
    };

    const serverExampleLink = `http://localhost:3001/verify-email?email=${encodeURIComponent(email || 'you@example.com')}&token=bd84cb3e233c2d32ffe9eb82cb345b8a165b663b`;
    const frontendExampleLink = `${window.location.origin}/verify-email-info?email=${encodeURIComponent(email || 'you@example.com')}&token=bd84cb3e233c2d32ffe9eb82cb345b8a165b663b`;

    return (
        <div className="form" style={{ padding: 24 }}>
            <h1>Vérifiez votre e-mail</h1>
            <p>Un e-mail de vérification vous a été envoyé. Merci de cliquer sur le lien dans l'e-mail ou de coller le code ci-dessous.</p>

            <div style={{ marginTop: 12 }}>
                <label>Adresse e-mail</label>
                <input value={email} onChange={e => setEmail(e.target.value)} type="email" />
            </div>
            <div style={{ marginTop: 12 }}>
                <label>Code de vérification</label>
                <input value={token} onChange={e => setToken(e.target.value)} type="text" />
            </div>
            <div style={{ marginTop: 12 }}>
                <button onClick={submitToken}>Valider le code</button>
            </div>

            {/*<div style={{ marginTop: 18 }}>*/}
            {/*    <p>Exemples de liens envoyés :</p>*/}
            {/*    <p>Si votre email contient un lien vers le serveur :</p>*/}
            {/*    <a href={serverExampleLink}>{serverExampleLink}</a>*/}
            {/*    <p style={{ marginTop: 8 }}>Ou lien direct vers cette page (pré-rempli) :</p>*/}
            {/*    <a href={frontendExampleLink}>{frontendExampleLink}</a>*/}
            {/*    <p style={{ marginTop: 8 }}>Message d'exemple :<br/>"Merci de vérifier votre email en cliquant ici ou en utilisant le code : bd84cb3e233c2d32ffe9eb82cb345b8a165b663b"</p>*/}
            {/*</div>*/}

            {status === 'loading' && <p>Vérification en cours…</p>}
            {status === 'success' && <p>Adresse vérifiée — redirection vers la page de connexion...</p>}
            {status && status !== 'loading' && status !== 'success' && <p style={{ color: 'red' }}>{status}</p>}
        </div>
    );
};

export default VerifyEmailInfo;
